import Vue from 'vue';
import VueRouter from 'vue-router';


Vue.use(VueRouter)

// 完整路由代码
export default new VueRouter({
	routes: [{
			path: '/',
			name: 'login',
			component: () => import('@/views/login/login.vue'),
		},
		{
			path: '/main',
			name: 'main',
			component: () => import('@/views/main'),
			children: [

				{
					path: '/',
					name: '',
					component: () => import('@/views/asset/account'),
				},
				/**  商品管理  */
				//商品
				{
					path: '/goods',
					name: 'goods',
					component: () => import('@/views/goods/all'),
				},
				//商品编辑
				{
					path: '/goodsEdit',
					name: 'goodsEdit',
					component: () => import('@/views/goods/edit'),
				},
				//供应商
				{
					path: '/supplier',
					name: 'supplier',
					component: () => import('@/views/goods/supplier'),
				},
				/**  商品管理  */
				//用户管理
				{
					path: '/users',
					name: 'users',
					component: () => import('@/views/users/all'),
				},
				/**  分享管理  */
				//分享人
				{
					path: '/shares',
					name: 'shares',
					component: () => import('@/views/shares/all'),
				},
				{
					path: '/sharesUsers',
					name: 'sharesUsers',
					component: () => import('@/views/shares/users'),
				},
				{
					path: '/sharesOrders',
					name: 'sharesOrders',
					component: () => import('@/views/shares/orders'),
				},
				//提现
				{
					path: '/cashout',
					name: 'cashout',
					component: () => import('@/views/shares/cashout'),
				},
				//电梯广告推广
				{
					path: '/addtshare',
					name: 'addtshare',
					component: () => import('@/views/shares/addtshare'),
				},
				/**  分享管理  */
				/**  订单  */
				//话费
				{
					path: '/telOrder',
					name: 'telOrder',
					component: () => import('@/views/order/tel'),
				},
				//电费
				{
					path: '/electricityOrder',
					name: 'electricityOrder',
					component: () => import('@/views/order/electricity'),
				},
				//订单详情
				{
					path: '/orderDetail',
					name: 'orderDetail',
					component: () => import('@/views/order/detail'),
				},
				//油卡
				{
					path: '/oilOrder',
					name: 'oilOrder',
					component: () => import('@/views/order/oil'),
				},
				//油码
				{
					path: '/oilCodeOrder',
					name: 'oilCodeOrder',
					component: () => import('@/views/order/oil_code'),
				},
				//水费
				{
					path: '/waterOrder',
					name: 'waterOrder',
					component: () => import('@/views/order/water'),
				},
				//燃气
				{
					path: '/gasOrder',
					name: 'gasOrder',
					component: () => import('@/views/order/gas'),
				},
				{
					path: '/videoOrder',
					name: 'videoOrder',
					component: () => import('@/views/order/video'),
				},
				/**  订单  */
			]
		}
	]
})
